export interface PagedResult<T> {
  items: T[];
  total: number;
}

/** Above this many pages, a response that keeps claiming more items exist is treated as lying, not retried forever. */
const MAX_PAGE_FETCHES = 50;

/**
 * Walks a page-by-page search endpoint from page 1 at `pageSize` until it has
 * every item the last response reported (`total`), or a page comes back
 * short — whichever happens first.
 */
export async function fetchAllPages<T>(
  fetchPage: (page: number, pageSize: number) => Promise<PagedResult<T>>,
  pageSize: number,
): Promise<T[]> {
  const items: T[] = [];

  for (let page = 1; page <= MAX_PAGE_FETCHES; page += 1) {
    const result = await fetchPage(page, pageSize);
    items.push(...result.items);

    if (result.items.length < pageSize || items.length >= result.total) {
      break;
    }
  }

  return items;
}
